export default __webpack_public_path__ + "static/media/5.ac47675e.gif";